<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <input type="text" v-model="response"  class="form-control text-center" placeholder="Introduzca aquí el IBAN" @change="ValidarRespuesta" @mouseleave="ValidarRespuesta" @keypress="ValidarRespuesta" @paste="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
</template>

<script>


import ValidateIban from "./Iban/ValidateIBAN.js"

export default {
  name: 'Iban',
  props: {

      response: String,
      FormularioTag: String,
      idQuestion: Number

  },

  methods: {

      ValidarRespuesta : function(){

        if (this.response != null)
        {
            if (this.response.length < 24)
            {

                var valido = false;

            } else {

                var valido = ValidateIban.fn_ValidateIBAN(this.response); 


            }


        } else {

            
            var valido = false;


        }


        if (valido == true)
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: this.response
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        } else {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: false,
                response: this.response
            };


            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        }

      }


  }
}
</script>